export default __webpack_public_path__ + "static/media/Home_BG-01.5fb81f53.png";